import { isEmpty } from 'lodash';
import { useAtomValue } from 'jotai';
import { useSelector } from 'react-redux';
import useSetExport from '@components/export/useSetExport';
import { metricFilterSelector } from '@store/trends/base/selectors';
import { comparisonIntervalSelector } from '@store/summaryContainer/comparison/selectors';
import { getFirstAppliedFilter, intervalSelector } from '@store/common/selectors';
import { dodAtom } from '@components/metrics-panel-hz/atoms';
import { pageMetaAtom } from '@src/atoms/pageMeta';
import metricsStore from '@src/globalStore/metricsStore';

function useSetExportBase() {
  const { flowPresetId } = useAtomValue(pageMetaAtom);
  const { flowConfigMeta } = metricsStore.getState();
  const appliedFilter = useSelector(getFirstAppliedFilter);
  const interval = useSelector(intervalSelector);
  const compareInterval = useSelector(comparisonIntervalSelector);
  const dodEnabled = useAtomValue(dodAtom) && !isEmpty(compareInterval);
  const metricFilter = useSelector(metricFilterSelector);

  const flowName = flowPresetId ? flowConfigMeta[flowPresetId]?.name : '';

  useSetExport({
    pageKey: 'trends',
    sectionKey: 'base',
    widgetKey: 'base',
    widgetInfo: { title: `Trends Export ${flowName ? `- ${flowName}` : ''}` },
    data: {
      appliedFilter,
      interval,
      compareInterval: dodEnabled ? compareInterval : null,
      metricFilter,
    },
    headers: [],
  });
}

export default useSetExportBase;
